import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import jQuery from 'jquery'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['apple-pay-button'];
// Make axios available globally in Vue components as this.$axios
Vue.prototype.$axios = axios;

// Set up jQuery globally if you need it
window.jQuery = jQuery;
window.$ = jQuery;

// Set up the axios interceptor for requests
axios.interceptors.request.use(
  (config) => {
    let token = store.getters.authToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Set up the axios interceptor for responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
